import vendorReducer from "./reducer"

const reducer = {
  reducers: vendorReducer
}

export default reducer